import styled from "styled-components";
import {brand, fontFamilies} from "theme/tokens";

/**
 * Styles for the sender's per-mode usage line (design `.usage` + `.meter`), split out of
 * `UsageMeter.tsx` in ui#1837 so the component file is markup and behavior only.
 */

export const UsageRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	/* Design line 693 puts .usage in the global mono list. */
	font-family: ${fontFamilies.mono};
	font-size: 12px;
	color: ${({theme}) => theme.tokens.ink2};
	/* No top margin: since ui#216 this is the payload HEADER pinned at the top of the summary box,
	   which owns the surrounding spacing (it used to trail the add-more row and needed the gap). */
	padding: 0 4px;
`;

export const Remaining = styled.span`
	font-weight: 700;
	color: ${({theme}) => theme.tokens.ink};
`;

export const Unlimited = styled.span`
	color: ${({theme}) => theme.tokens.teal};
	font-weight: 700;
`;

export const MeterTrack = styled.div`
	height: 8px;
	border-radius: 999px;
	background: ${({theme}) => theme.tokens.fieldLine};
	overflow: hidden;
	margin-top: 7px;
`;

/**
 * The heat fill (design `.meter-fill.heat`): a single blue-free green→amber→red gradient anchored to
 * the FULL track and revealed left-to-right. `background-size` scales the gradient so whatever
 * fraction is filled always shows the gradient up to its matching heat color.
 *
 * The three stops were hardcoded hex until ui#1837. They are the same colours by value, sourced
 * correctly now: the green is the PER-MODE `teal` token, which is why dark mode used to paint a
 * light-mode green here; amber and red are `brand.warning`/`brand.error`, mode-independent by design
 * and shared with the download-usage banner's two tones, so the two meters escalate through the same
 * colours.
 */
export const MeterFill = styled.div<{$pct: number; $bg: number}>`
	height: 100%;
	border-radius: 999px;
	width: ${({$pct}) => $pct}%;
	background-image: linear-gradient(
		90deg,
		${({theme}) => theme.tokens.teal},
		${brand.warning} 62%,
		${brand.error}
	);
	background-repeat: no-repeat;
	background-size: ${({$bg}) => $bg}% 100%;
	transition: width 0.35s ease;
`;
